import React from 'react';
import PropTypes from 'prop-types';
import Grid from '../components/Grid.jsx';
import FormikTextField from '../formik-fields/FormikTextField.jsx';

const GridFormikTextField = ({ gridProps, ...props }) => {
  return (
    <Grid item {...gridProps}>
      <FormikTextField {...props} />
    </Grid>
  );
};

GridFormikTextField.propTypes = {
  disabled: PropTypes.bool,
  label: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  value: PropTypes.any,
  fieldProps: PropTypes.object,
  gridProps: PropTypes.object.isRequired,
};

export default GridFormikTextField;
